module.exports = __webpack_public_path__ + "static/img/contact-bg.356a6ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/contact-bg.png
// module id = 1dj6
// module chunks = 2